import { get, isEmpty, isUndefined } from 'lodash-es'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
// import goTo from 'vuetify/es5/services/goto'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_MUTATIONS from '@/js/plugins/store/modules/app/mutation-types.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'

let titleTimeout

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    // return goTo(savedPosition.y)
    return savedPosition
  } else {
    const position = {}
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash

      // specify offset of the element
      // if (to.hash === '#anchor2') {
      //   position.offset = { y: 100 }
      // }

      // header offset
      position.offset = { y: 180 }

      // bypass #1number check
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false
    }

    return new Promise(resolve => {
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // coords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }

      // wait for the out transition to complete (if necessary)
      this.app.$root.$once('triggerScroll', () => {
        // if the resolved position is falsy or an empty object,
        // will retain current scroll position.
        resolve(position)
      })
    })
  }
}

const setTitle = (to, router) => {
  // console.log('setTitle')

  const translationKey = `pageTitles.${to.name}`
  const translationResult = router.app.$root.$t(translationKey)
  const translation = translationKey !== translationResult ? translationResult : undefined

  const routePageTitle =
    to.params.pageTitle ||
    get(router.app.$root.$store, ['state', STOREMODULES.APP, APP_CONSTANTS.PAGE_TITLE, to.name]) ||
    translation

  const typoPageTitle = get(router.app.$root.$store, [
    'state',
    STOREMODULES.APP,
    APP_CONSTANTS.PAGE_TITLE,
    'default',
  ])

  router.app.$root.$store.commit(
    `${STOREMODULES.APP}/${APP_MUTATIONS.SET_ROUTE_TITLE}`,
    routePageTitle,
  )

  document.title =
    routePageTitle && to.name !== 'default' ? `${routePageTitle} | ${typoPageTitle}` : typoPageTitle
  return !!routePageTitle
}

Vue.use(VueRouter)

export const router = new VueRouter({
  // mode: 'history',
  scrollBehavior,
  routes,
})

const checkLoggedIn = async to => {
  const storeUser = get(
    router,
    [
      'app',
      '$root',
      '$store',
      'state',
      STOREMODULES.APP,
      APP_CONSTANTS.APP_CONFIG,
      APP_CONSTANTS.USER,
    ],
    {},
  )

  // Override notLoggedIn based on Worker Response
  const workerIsActive = window?.authWorker?.active?.state === 'activated'
  let workerHasToken = workerIsActive
    ? await fetch('/issessionactive').catch(() => {
        return { status: 404 }
      })
    : { status: 404 }

  if (workerHasToken.status === 404) {
    console.log(
      workerIsActive
        ? 'Request was not intercepted by worker, unregister and reregister worker, then retry once...'
        : 'No active worker found...',
    )

    if (!workerIsActive) {
      // Unregister worker and reload page
      await navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister()
        }
      })

      await window.registerServiceWorker()
      if (window.authWorker.waiting) {
        console.warn(
          'Load Service Worker: Auth worker in waiting state. Sending skipWaiting event.',
        )
        window.authWorker.waiting.postMessage({ action: 'skipWaiting' })
      }

      console.log('Worker state:', window?.authWorker?.active?.state)
      console.log('Worker registered')
    }

    console.log('Worker retry request...')

    const forced = isEmpty(storeUser)
    const requestType = forced ? '/issessionactiveforcerefresh' : '/issessionactive'
    workerHasToken = await fetch(requestType).catch(() => {
      return { ok: false, forced }
    })
    workerHasToken.forced = forced
  }
  console.log('Worker has token:', workerHasToken)
  const route = {
    name: to.name,
    params: to.params,
  }

  const urlParams = new URLSearchParams(window.location.search)
  const relogin = urlParams.get('impersonate_relogin')

  if (relogin) {
    route.name = relogin
    route.params = {}
  }

  if (
    !workerHasToken.ok &&
    // to.name !== 'default' &&
    !get(storeUser, APP_CONSTANTS.USERNAME)
  ) {
    if (route.name !== 'default') {
      // Test: Manually set return route
      let oldRoute = structuredClone(route)
      router.app.$root.$store.commit(`${STOREMODULES.APP}/${APP_MUTATIONS.SET_RETURN_ROUTE}`, oldRoute)
    }

    route.name = 'default'
    route.params = { notLoggedIn: true }
  }

  return isEmpty(route) ? to : route
}

const setScope = to => {
  const scope = get(to, ['meta', 'scope'])
  console.log(`Change scope: ${scope} for page ${to?.name}`)
  // router.app.$root.$store.commit(
  //   `${STOREMODULES.APP}/${APP_MUTATIONS.SET_SCOPE}`,
  //   get(FILTER_CONSTANTS, ['IS_OUTLET', scope]),
  //   FILTER_CONSTANTS.IS_OUTLET.CURRENT,
  // )
  if (isUndefined(scope)) {
    return
  }
  router.app.$root.$store.dispatch(`${STOREMODULES.APP}/${APP_ACTIONS.CHANGE_SCOPE}`, {
    scope,
    vm: router.app.$root,
  })
}

const getCurrentProductScope = () => {
  const currentRoute = get(
    router,
    ['app', '$root', '$store', 'state', STOREMODULES.APP, APP_CONSTANTS.SCOPE],
    FILTER_CONSTANTS.SCOPE.BIKES,
  )
  return currentRoute === FILTER_CONSTANTS.SCOPE.BIKES ||
    currentRoute === FILTER_CONSTANTS.SCOPE.SERVICE
    ? currentRoute
    : FILTER_CONSTANTS.SCOPE.BIKES
}

const checkReturnRoute = () => {
  const returnRoute = get(
    router,
    ['app', '$root', '$store', 'state', STOREMODULES.APP, APP_CONSTANTS.RETURN_ROUTE],
    {},
  )
  if (!isEmpty(returnRoute)) {
    router.app.$root.$store.commit(
      `${STOREMODULES.APP}/${APP_MUTATIONS.SET_RETURN_ROUTE}`,
      undefined,
    )
  }
  return returnRoute
}

const beforeEachFlow = async (to, from, next) => {
  const hideHeader = !!get(to, ['meta', 'hideHeader'], false)

  // console.log(from)
  // console.log(to)

  router.app.$root.$store.commit(
    `${STOREMODULES.APP}/${APP_MUTATIONS.SET_APP_BAR_IS_HIDDEN}`,
    hideHeader,
  )

  // Show login
  if (get(to, ['params', 'notLoggedIn'])) {
    console.log('show default notLoggedIn')
    next()
    return
  }

  const loggedInRoute = await checkLoggedIn(to, from)
  if (!isEmpty(loggedInRoute) && loggedInRoute.name !== to.name) {
    console.log('show default for login')
    next(loggedInRoute)
    return
  }

  const perm = to?.meta?.perm
  // console.log(`router: check ${perm}`, to)
  if (
    perm &&
    !router.app.$root.$store.getters[`${STOREMODULES.APP}/${APP_GETTERS.HAS_ROLE}`](perm)
  ) {
    console.log(
      `router: no permission for ${perm}`,
      get(router, [
        'app',
        '$root',
        '$store',
        'state',
        STOREMODULES.APP,
        APP_CONSTANTS.APP_CONFIG,
        APP_CONSTANTS.USER,
      ]),
    )
    next(false)
    return
  }

  const returnRoute = checkReturnRoute()
  if (!isEmpty(returnRoute)) {
    console.log('show return route')
    next(returnRoute)
    return
  }

  console.log(to)
  console.log(getCurrentProductScope())
  if (to?.name === 'products') {
    next({ name: getCurrentProductScope() })
  }

  next()
}

router.beforeEach((to, from, next) => {
  if (!get(router, 'app.$root.$store.state')) {
    Vue.nextTick(async () => {
      await beforeEachFlow(to, from, next)
    })
  } else {
    beforeEachFlow(to, from, next)
  }
})

router.afterEach(to => {
  // Page Title Hack
  if (titleTimeout) {
    clearTimeout(titleTimeout)
  }
  Vue.nextTick(() => {
    router.app.$root.$emit('triggerScroll')
    setScope(to)
    if (!setTitle(to, router)) {
      titleTimeout = setTimeout(() => {
        setTitle(to, router)
      }, 1000)
    }
  })
})

export default router
